<template>
  <v-container
    fluid
    pa-0
    fill-height
    class="align-start"
    style="max-width: 100%"
  >
    <div class="d-flex flex-column flex-grow-1 fill-height">
      <HistoryTable />
    </div>
  </v-container>
</template>

<script>
import HistoryTable from '@/modules/history/components/HistoryTable'

export default {
  name: 'History',

  components: {
    HistoryTable
  }
}
</script>
